'use strict';

define('customPlugins/atnOverlayContainer',[
        'knockout', 'lodash', 'jquery'
    ],
    function(ko, _, $) {
        
        ko.bindingHandlers.atnOverlayContainer = {
            
            init: function(element, valueAccessor) {
                var overlayElement = element,
                    overlayContentContainer = overlayElement.children[0],
                    overlayVisible = valueAccessor().toggleOverlay(),
                    overlayPosition = valueAccessor().position,
                    hideOverlayCallback = valueAccessor().hideCallback;

                element.addEventListener('click', handleOverlayClick);

                function handleOverlayClick(e){
                    if($(e.target).data() && $(e.target).data().bind && $(e.target).data().bind.match('atnOverlayContainer')){
                        _.defer( throttledToggle,
                            {
                                overlayElement: overlayElement,
                                overlayContents: overlayContentContainer,
                                state: 'hide',
                                position: overlayPosition
                            }
                        );
                        _.delay(hideOverlayCallback, 300);
                    }
                }
            },

            update: function(element, valueAccessor) {
                var overlayElement = element,
                    overlayContentContainer = overlayElement.children[0],
                    overlayPosition = valueAccessor().position,
                    overlayVisible = valueAccessor().toggleOverlay();

                _.defer( throttledToggle,
                    {
                        overlayElement: overlayElement,
                        overlayContents: overlayContentContainer,
                        state: !overlayVisible? 'hide' : 'show',
                        position: overlayPosition
                    }
                );
            }
        };

        var throttledToggle = _.throttle(toggleContent, 400);

        function toggleContent(options) {

            var overlaySetAttr = options.overlayElement.setAttribute.bind(options.overlayElement);
            var overlayContentSetAttr = options.overlayContents.setAttribute.bind(options.overlayContents);

            if (options.state === 'hide') {
                _.delay(overlaySetAttr, 400, 'atn-role', 'hidden');
                if(options.position === 'right'){
                    _.delay(overlayContentSetAttr, 100, 'atn-role', 'hidden-right');
                } else if(options.position === 'center'){
                    _.delay(overlayContentSetAttr, 100, 'atn-role', 'hidden-center');
                }else{
                    _.delay(overlayContentSetAttr, 100, 'atn-role', 'hidden');
                }
            } else if (options.state === 'show') {
                _.delay(overlaySetAttr, 200, 'atn-role', 'shown');
                if(options.position === 'right'){
                    _.delay(overlayContentSetAttr, 400, 'atn-role', 'shown-right');
                } else if(options.position === 'center'){
                    _.delay(overlayContentSetAttr, 400, 'atn-role', 'shown-center');
                }else {
                    _.delay(overlayContentSetAttr, 400, 'atn-role', 'shown');
                }
            }
        }

    });
